module.exports = __webpack_public_path__ + "img/logo_clinics.12ad00ec.png";